import React from "react";

import { FormattedMessage, injectIntl } from "react-intl";
// Bootstrap
import { Row, Col } from "react-bootstrap";

// Styles
import "./index.scss";

// Images
import ieeeSALogo from "../../img/ieee-sa-logo-text.png";
import ieeeSALogoBlack from "../../img/ieee_logo_black.png";

const Header = ({ intl, ...props }) => {
    return (
        <>
            <header className="page-header">
                <div className="global-menu">
                    <div className="container-fluid global-menu-container">
                        <Row>
                            <Col md={8} className="p-0">
                                <nav className="navbar navbar-expand-md navbar-light global-menu-navbar pl-0 pr-0">
                                    <div className="collapse navbar-collapse" id="navbarCollapse">
                                        <div className="navbar-nav global-menu-navbar-nav fusion-secondary-header">
                                            <a
                                                className="pl-0"
                                                href="https://www.ieee.org/index.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage id="page.header.menu.link1" />
                                            </a>

                                            <a
                                                href="http://ieeexplore.ieee.org/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage
                                                    id="page.header.menu.link2"
                                                    defaultMessage="IEEE {xplore}"
                                                    values={{
                                                        xplore: <i>Xplore&reg;</i>,
                                                    }}
                                                />
                                            </a>

                                            <a
                                                href="https://standards.ieee.org/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage id="page.header.menu.link3" />
                                            </a>

                                            <a
                                                href="https://spectrum.ieee.org/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage id="page.header.menu.link4" />
                                            </a>

                                            <a
                                                href="https://www.ieee.org/sitemap.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage id="page.header.menu.link5" />
                                            </a>
                                        </div>
                                    </div>
                                </nav>
                            </Col>
                            <Col md={4} className="p-0">
                                <nav className="navbar navbar-expand-md navbar-light global-menu-navbar pr-0 navbarP410">
                                    <div className="collapse navbar-collapse" id="navbarCollapse">
                                        <div className="navbar-nav global-menu-navbar-nav ">
                                            <a
                                                className="pl-0"
                                                href="https://standards.ieee.org/develop/etools/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FormattedMessage id="page.header.menu.link6" />
                                            </a>
                                        </div>
                                    </div>
                                </nav>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="app-menu">
                    <div
                        className="container-fluid p-0 app-menu-container"
                        id="app-menu-container"
                    >
                        <Row className="p-0 app-menu-navbar" id="app-menu-navbar">
                            <Col md={9} className="p-0">
                                <nav className="navbar navbar-expand-md navbar-light">
                                    <a
                                        href="https://standards.ieee.org/"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            id="ieee-logo"
                                            className="ieee-logo img-responsive pull-right"
                                            src={ieeeSALogo}
                                            alt="IEEE Logo"
                                        />
                                    </a>
                                </nav>
                            </Col>
                            <Col md={3} className="p-0">
                                <nav className="navbar navbar-expand-md navbar-light navbarImgP410">
                                    <a href="https://www.ieee.org/" rel="noopener noreferrer">
                                        <img
                                            id="ieee-logo"
                                            className="ieee-logo img-responsive pull-right"
                                            src={ieeeSALogoBlack}
                                            alt="IEEE Logo"
                                        />
                                    </a>
                                </nav>
                            </Col>
                        </Row>
                    </div>
                </div>
            </header>
        </>
    );
};

export default injectIntl(Header);
